import React, { Component, Fragment } from 'react'
import { FormGroup, FormControl, ControlLabel, Button, Tabs, Tab, Form, InputGroup, Col, Row } from 'react-bootstrap'
import {getParams, makeUniqueKey, end_point, daysOfWeek, divisionOptions, getSeasons, getProgramTypeOptions, normalizeProgramTypeBucket, formatSessionDateLabel, sortProgramSessions} from './helper'
import Moment from 'moment'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faTimes, faClone } from '@fortawesome/free-solid-svg-icons'
import PricingTab from './ProgramModalTabs/pricingTab'
import WaiverTab from './ProgramModalTabs/waiverTab'
import ProgramTab from './ProgramModalTabs/programTab'
import VirtualizedSelect from 'react-virtualized-select'
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import MomentUtils from '@date-io/moment'
import { MuiThemeProvider } from "@material-ui/core"
import hoopstirTheme from './CSSOverrides'

var $ = require('jquery')
const programSessionDayOptions = [
  ...daysOfWeek,
  <option key='9' value="Date">Date</option>,
]


class ProgramForm extends Component {
  constructor(props) {
    super(props);
    if (props.mode === "edit") {
      var defaultPlaceholders = {
        "type": props.selectedItem.type,
        "ages": props.selectedItem.ages,
        "division": props.selectedItem.division,
        "group_name": props.selectedItem.group_name,
        "head_coach": props.selectedItem.head_coach,
        "enrollment_goal": props.selectedItem.enrollment_goal,
        "enrollment_maximum": props.selectedItem.enrollment_maximum,
        "enrolment_flex": props.selectedItem.enrolment_flex,
        "expected_costs": props.selectedItem.expected_costs,
        "program_description": props.selectedItem.program_description,
        "additional_notes": props.selectedItem.additional_notes,
        "plans": props.selectedItem.plans,
        "team_fees": props.selectedItem.plans,
        "player_fees": props.selectedItem.clonedProgram ?props.selectedItem.clonedProgram.plans : [],
        "projected_program_profits": props.selectedItem.projected_program_profits,
        "coach_notes": props.selectedItem.coach_notes,
        "item_0_cost": props.selectedItem.item_0_cost,
        "item_1_cost": props.selectedItem.item_1_cost,
        "item_2_cost": props.selectedItem.item_2_cost,
        "start_date": props.selectedItem.start_date,
        "end_date": props.selectedItem.end_date,
        "registration_start_date": props.selectedItem.registration_start_date === "1970-01-01T00:00:00.000Z" ? null : props.selectedItem.registration_start_date,
        "registration_end_date": props.selectedItem.registration_end_date === "1970-01-01T00:00:00.000Z" ? null : props.selectedItem.registration_end_date,
        "DOB_max": props.selectedItem.DOB_max,
        "assistantCoaches": props.selectedItem.assistantCoaches,
        "sessions": props.selectedItem.sessions,
        "season": props.selectedItem.season,
        "waiver": props.selectedItem.waiver ? props.selectedItem.waiver : "",
        "league": props.selectedItem.type === "rep league" || props.selectedItem.type === "tournament" ? true : false,
        "ageVerify": props.selectedItem.ageVerify ? props.selectedItem.ageVerify : false,
        "clone":props.selectedItem.clone === true ? true : false,
        "player_goal" : props.selectedItem.clonedProgram ?props.selectedItem.clonedProgram.enrollment_goal : null,
        "player_max" : props.selectedItem.clonedProgram ?props.selectedItem.clonedProgram.enrollment_maximum: null,
        "player_flex" : props.selectedItem.clonedProgram ?props.selectedItem.clonedProgram.enrolment_flex : null,
        "player_costs" : props.selectedItem.clonedProgram ?props.selectedItem.clonedProgram.expected_costs: null,
        "player_profit" : props.selectedItem.clonedProgram ?props.selectedItem.clonedProgram.projected_program_profits : null,
        "programUDFs": props.selectedItem.udfs && props.selectedItem.udfs.length > 0 ? props.selectedItem.udfs : null,
        "VTsessions": props.selectedItem.VTsessions ? props.selectedItem.VTsessions : [] 
      }
    } else {
      defaultPlaceholders = {
        "type": "",
        "ages": "",
        "division": null,
        "group_name": "",
        "head_coach": "",
        "enrollment_goal": "",
        "enrollment_maximum": "",
        "enrolment_flex": "",
        "expected_costs": "",
        "program_description": "",
        "additional_notes": "",
        "plans": [],
        "team_fees": [],
        "player_fees": [],
        "projected_program_profits": "",
        "coach_notes": "",
        "item_0_cost": "",
        "item_1_cost": "",
        "item_2_cost": "",
        "start_date": null,
        "end_date": null,
        "registration_start_date": null,
        "registration_end_date": null,
        "DOB_max": null,
        "assistantCoaches": [],
        "sessions": [],
        "season": "",
        "waiver": "",
        "league": props.league ? true : false,
        "ageVerify": false,
        // "VTsessions": []
        // "programUDFs": []
      }
    }

    this.state = {
      addAssistantCoachVisible: false,
      addVTVisible: false,
      addSessionVisible: props.mode === "edit" ? false : true,
      ageVerify: defaultPlaceholders.ageVerify ? defaultPlaceholders.ageVerify : false,
      allseasonOptions: [],
      assistantCoaches: (defaultPlaceholders.assistantCoaches || []).filter((coach) => coach),
      availablePlanOptions: [],
      clone: defaultPlaceholders.clone ? defaultPlaceholders.clone : false,
      coachSelectOptions: [],
      defaultPlaceholders: defaultPlaceholders,
      custom_waiver: defaultPlaceholders.waiver? defaultPlaceholders.waiver.slice(3):defaultPlaceholders.waiver,
      divisions: [ "boys", "girls", "co-ed"],
      DOB_max: defaultPlaceholders.DOB_max? Moment.utc(defaultPlaceholders.DOB_max): null,
      end_date: defaultPlaceholders.end_date? Moment.utc(defaultPlaceholders.end_date): null,
      league: defaultPlaceholders.league ? defaultPlaceholders.league : false,
      mode: props.mode,
      openEnrolhint: false,
      organization_id: localStorage.getItem("organization_id"),
      organization_waiver: "",
      organization_merch: [],
      organization_venues: [],
      activeTab: '1',
      formChangeNonce: 0,
      newProgramReady: false,
      plans: defaultPlaceholders.plans,
      player_fees_visible: true,
      plans_visible: true,
      player_fees: defaultPlaceholders.player_fees,
      planMap: {},
      priceMap: {},
      selectedProfitPlan: defaultPlaceholders.plans && defaultPlaceholders.plans.length > 0 ? defaultPlaceholders.plans[0] : '',
      selectedCoachValues: [defaultPlaceholders.head_coach, ...(defaultPlaceholders.assistantCoaches || [])].filter(Boolean),
      requireProof: false,
      start_date: defaultPlaceholders.start_date? Moment.utc(defaultPlaceholders.start_date): null,
      registration_start_date: defaultPlaceholders.registration_start_date? Moment.utc(defaultPlaceholders.registration_start_date): null,
      registration_end_date: defaultPlaceholders.registration_end_date? Moment.utc(defaultPlaceholders.registration_end_date): null,
      sessions: defaultPlaceholders.sessions,
      session_start_time: '12:00',
      session_end_time: '12:00',
      session_day: 'select',
      session_date: null,
      session_location_mode: 'existing',
      session_location_custom: '',
      session_repeat_weekly: false,
      selectedVenueIndex: '',
      spinner: false,
      team_fees: defaultPlaceholders.team_fees,
      team_fees_visible: true,
      token: getParams().jwt,
      waiver_type: defaultPlaceholders.waiver?(defaultPlaceholders.waiver.slice(0,2) === "CW"? "1": "0"):"0",
      orgUDFS: null,
      programTypeLabels: [],
      programUDFs: defaultPlaceholders.programUDFs ? defaultPlaceholders.programUDFs: null,
      udfHint: false,
      VTsessions: defaultPlaceholders.VTsessions ? defaultPlaceholders.VTsessions : []
    }
  }

  componentDidMount() {

    if (this.props.mode === "edit" && this.props.selectedItem.VTsessions) {
      this.props.selectedItem.VTsessions.forEach(session => {
        session.addSession = true
      })
      console.log("props in program from", this.props)
    }

    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id,
      },
      method: "GET",
      dataType: "json",
      url: `${end_point()}/plans`,
    }).then(this.plansGetHandler.bind(this))

    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id,
        "user_type": "coachadmin"
      },
      method: "GET",
      dataType: "json",
      url: `${end_point('users')}/users`,
    }).then(this.coachesGetHandler.bind(this))

    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id,
      },
      method: "GET",
      dataType: "json",
      url: `${end_point('organizations')}/organizations`,
    }).then((org) => this.organizationGetHandler(org))
    this.renderSeason()
  }

  componentDidUpdate(prevProps) {
    const previousSeason = prevProps.selectedItem && prevProps.selectedItem.season
    const currentSeason = this.props.selectedItem && this.props.selectedItem.season

    if (this.props.mode === "edit" && previousSeason !== currentSeason) {
      this.renderSeason()
    }
  }

  handleDateChange = (date, field) => {
    this.setState({ [field]: date }, this.refreshNewProgramReady)
  }

  handleProgramTabSelect = (activeKey) => {
    if (!activeKey) {
      return
    }
    this.setState({ activeTab: `${activeKey}` })
  }

  notifyFormChange = () => {
    this.refreshNewProgramReady()
  }

  refreshNewProgramReady = () => {
    if (this.state.mode === "edit") {
      return
    }
    this.setState({
      newProgramReady: this.checkFields("new", true)
    })
  }

  goToPricingTab = () => {
    this.setState({
      activeTab: '2',
      newProgramReady: this.state.mode === "edit" ? true : this.checkFields("new", true)
    })
  }

  goToWaiversTab = () => {
    this.setState({
      activeTab: '3',
      newProgramReady: this.state.mode === "edit" ? true : this.checkFields("new", true)
    })
  }

  goToDetailsTab = () => {
    this.setState({ activeTab: '1' })
  }

  plansGetHandler = (data) => {
    var plans = data.message;
    var temp = [];
    var options = [];
    var planMap = {};
    var priceMap = {};
    plans.forEach((plan) => {
      planMap[plan._id] = plan.plan_name;
      priceMap[plan._id] = plan.plan_price;
      temp.push(<option key={plan._id} value={plan._id}>{plan.plan_name} - {plan.plan_price}</option>)
      options.push({ value: plan._id, label: `${plan.plan_name} - ${plan.plan_price}` })
    })
    this.setState({ availablePlans: temp, availablePlanOptions: options, planMap: planMap, priceMap: priceMap });
  }

  coachesGetHandler = (coaches) => {
    var temp = [];
    var options = [];
    var coachMap = {};
    var option = null;
    const coachList = coaches && Array.isArray(coaches.message) ? coaches.message : []

    if (coachList.length === 0) {
      options.push({ value: '', label: 'No coaches available', disabled: true })
    }

    coachList.forEach((coach) => {
      coachMap[coach._id] = `${coach.first_name} ${coach.last_name}`
      temp.push(<option key={coach._id} value={coach._id}>{coach.first_name + " " + coach.last_name}</option>)
      options.push({ value: coach._id, label: `${coach.first_name} ${coach.last_name}` })
    })

    this.setState({ coachOptions: temp, coachSelectOptions: options, coachMap: coachMap });
  }

  udfChoices = (orgUDFS) => {
    var options = []
    orgUDFS.forEach(udf => {
      options.push(
        { label: udf.label, value: udf.key }
      )
    })
    console.log('udfChoices', options)
    return options
  }

  organizationGetHandler = (organization ) => {
    var udfs = organization.udfs ? this.udfChoices(organization.udfs) : null
    const programTypeLabels = organization.program_type_labels ? organization.program_type_labels : []
    this.setState({ 
      organization_waiver: organization.waiver, 
      organization_merch: organization.merch,
      organization_venues: Array.isArray(organization.venues) ? organization.venues : [],
      orgUDFS: udfs,
      programTypeLabels
     })
  }

  handleUpdateSubmit = () => {
    this.setState({ spinner: true })
    const { selectedItem } = this.props
    if (selectedItem.status === "Expired") {
      window.alert("Expired programs cannot be re-used.  Clone the program from Programs page to create a new program using this program's details.")
      this.setState({ spinner: false })
    } else {
      var check = this.checkFields("update")
      var formFields = this.getFormFields()
      console.log('handleUpdateSubmit fields:\n', formFields)
      if(check){
        if (formFields.clonedProgram === null) {
          delete formFields.clonedProgram
        }
        this.props.patchUpdateMethod(formFields, this.props.selectedItem._id);
      } else {
        this.setState({ spinner: false })
      }
    }  
  }

  handleCloseModal = () => {
    if (this.state.mode === "edit") {
      this.props.handleCloseModalEdit()
    } else {
      this.props.handleCloseModalNew()
    }
  }

  handleArchiveSubmit = () => {
    if (window.confirm(`Select OK to confirm Archive Program: ${document.getElementById("group_name").value}?`)) {
      this.setState({ spinner: true })
      var formFields = { archived: true }
      this.props.patchUpdateMethod(formFields, this.props.selectedItem._id)
    }
  }

  handleNewSubmit = () => {
    this.setState({ spinner: true })
    var check = this.checkFields("new")
    var formFields = this.getFormFields()
    console.log('in handleNewSubmit', formFields)
    if (check) {
      if (this.state.league) {
        formFields.createLeague = true
      }
      console.log('handleNewSubmit passed check', formFields, JSON.stringify(({ 'document': formFields })))
      this.props.postMethod(formFields)
    } else {
      this.setState({ spinner: false })
    }
  }

  showHint = hint => {
    var change = !this.state[hint]
    this.setState({ [hint]: change})
  }

  evaluateMerch = (item) => {
    var element = document.getElementById(item)
    var value = element && element.value !== "" ? +element.value : null
    return value
  }

  getDateInTimezone = (dateString) => {
    var date = new Date(dateString);
    var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var dateInTimezone = new Date(date.toLocaleString('en-US', { timeZone: timezone }));
    return dateInTimezone.getTime();
  }

  getFieldValue = (fieldId) => {
    const field = document.getElementById(fieldId)
    return field ? field.value : ""
  }

  isNonEmpty = (value) => {
    return value !== null && value !== undefined && `${value}`.trim() !== ""
  }

  getNewProgramChecklist = () => {
    const { league, addSessionVisible, addVTVisible, addAssistantCoachVisible, custom_waiver, waiver_type, sessions, VTsessions } = this.state
    const checklist = []
    const check = (label, complete, section) => ({
      label,
      complete,
      section
    })

    if (league) {
      checklist.push(check("Select commissioner", this.isNonEmpty(this.getFieldValue("commissioner_1")), "Details"))
      checklist.push(check("Set player goal", this.isNonEmpty(this.getFieldValue("player_goal")), "Pricing"))
      checklist.push(check("Set player maximum", this.isNonEmpty(this.getFieldValue("player_max")), "Pricing"))
      checklist.push(check("Set player costs", this.isNonEmpty(this.getFieldValue("player_costs")), "Pricing"))
      checklist.push(check("Add team fee plan", this.state.team_fees.length > 0, "Pricing"))
      checklist.push(check("Add player fee plan", this.state.player_fees.length > 0, "Pricing"))
    } else {
      checklist.push(check("Choose program type", this.isNonEmpty(this.getFieldValue("type")), "Details"))
      checklist.push(check("Select a coach", this.isNonEmpty(this.getFieldValue("head_coach")), "Details"))
      checklist.push(check("Choose season", this.isNonEmpty(this.getFieldValue("season")), "Details"))
      checklist.push(check("Enter age group", this.isNonEmpty(this.getFieldValue("ages")), "Details"))
      checklist.push(check("Choose division", this.isNonEmpty(this.getFieldValue("division")), "Details"))
      checklist.push(check("Enter group name", this.isNonEmpty(this.getFieldValue("group_name")), "Details"))
      checklist.push(check("Set start date", this.isNonEmpty(this.getFieldValue("start_date")), "Details"))
      checklist.push(check("Set end date", this.isNonEmpty(this.getFieldValue("end_date")), "Details"))
      checklist.push(check("Set open enrolment", this.isNonEmpty(this.getFieldValue("registration_start_date")), "Details"))
      checklist.push(check("Set close enrolment", this.isNonEmpty(this.getFieldValue("registration_end_date")), "Details"))
      checklist.push(check("Add payment plan", this.state.plans.length > 0, "Pricing"))
      checklist.push(check("Set enrolment goal", this.isNonEmpty(this.getFieldValue("enrollment_goal")), "Pricing"))
      checklist.push(check("Set enrolment maximum", this.isNonEmpty(this.getFieldValue("enrollment_maximum")), "Pricing"))
    }

    checklist.push(check("Add at least one session", sessions.length > 0 || VTsessions.length > 0, "Flow"))
    checklist.push(check("No draft session open", !addSessionVisible && !addVTVisible, "Flow"))
    checklist.push(check("No assistant coach draft open", !addAssistantCoachVisible, "Flow"))
    checklist.push(check("Waiver text entered when custom waiver is selected", waiver_type !== "1" || this.isNonEmpty(custom_waiver), "Flow"))

    return checklist
  }

  getCreateProgramBlocker = () => {
    if (this.state.mode === "edit") {
      return null
    }

    const checklist = this.getNewProgramChecklist()
    return checklist.find((item) => !item.complete) || null
  }

  getFormFields = () => {
    const { league } = this.state
    console.log('in getFormFields')
    const getNumericFieldValue = (fieldId) => {
      const value = this.getFieldValue(fieldId)
      return value === "" ? 0 : +value
    }
    if (league) {
      var clonedProgram = {
        "plans":  league ? this.state.player_fees : '',
        "enrollment_goal": getNumericFieldValue("player_goal"),
        "enrollment_maximum": getNumericFieldValue("player_max"),
        "enrolment_flex": getNumericFieldValue("player_flex"),
        "expected_costs": getNumericFieldValue("player_costs"),
        "projected_program_profits": getNumericFieldValue("player_profit")
      }
    }
    
    return {
      "type": document.getElementById("type").value,
      "type_bucket": normalizeProgramTypeBucket(document.getElementById("type").value),
      "ages": document.getElementById("ages").value,
      "division": document.getElementById("division").value,
      "group_name": document.getElementById("group_name").value,
      "head_coach": league ? document.getElementById("commissioner_1").value : document.getElementById("head_coach").value,
      "commissioner_1": league ? document.getElementById("commissioner_1").value : '',
      "enrollment_goal": league ? getNumericFieldValue("team_goal") : getNumericFieldValue("enrollment_goal"),
      "enrollment_maximum": league ? getNumericFieldValue("team_max") : getNumericFieldValue("enrollment_maximum"),
      "enrolment_flex": league ? getNumericFieldValue("team_flex") : getNumericFieldValue("enrolment_flex"),
      "expected_costs": league ? getNumericFieldValue("team_costs") : getNumericFieldValue("expected_costs"),
      "program_description": this.getFieldValue("program_description"),
      "additional_notes": this.getFieldValue("additional_notes"),
      "plans": league ? this.state.team_fees : this.state.plans,
      "projected_program_profits": league ? getNumericFieldValue("team_profit") : getNumericFieldValue("projected_program_profits"),
      // "coach_notes": league ? '' : document.getElementById("coach_notes").value,
      "item_0_cost": this.evaluateMerch("item_0_cost"),
      "item_1_cost": this.evaluateMerch("item_1_cost"),
      "item_2_cost": this.evaluateMerch("item_2_cost"),
      "start_date": this.getDateInTimezone(this.getFieldValue("start_date")),
      "end_date": this.getDateInTimezone(this.getFieldValue("end_date")),
      "registration_start_date": this.getDateInTimezone(this.getFieldValue("registration_start_date")),
      "registration_end_date": this.getDateInTimezone(this.getFieldValue("registration_end_date")),
      // "DOB_max" : document.getElementById("DOB_max").value,
      "assistantCoaches": this.state.assistantCoaches,
      "sessions": this.state.sessions,
      "season": this.getFieldValue("season"),
      "waiver": this.state.waiver_type === "0"? `OW ${this.state.organization_waiver}`: `CW ${this.state.custom_waiver}`,
      "ageVerify": this.state.ageVerify,
      "clonedProgram": league ? clonedProgram : null,
      "udfs": this.state.programUDFs,
      "VTsessions": this.state.VTsessions
    }
  }

  handleAgeVerify = (e) => {
    console.log('e??', e)
    this.setState({ ageVerify: e}, this.refreshNewProgramReady)
  }

  handlePlanSelectionChange = (choices, goal, cost, profit, list) => {
    const selectedValues = (choices || []).map((choice) => choice.value).filter((value) => value)
    const nextSelectedProfitPlan = list === 'plans' ? (selectedValues[0] || '') : this.state.selectedProfitPlan
    const nextState = {
      [list]: selectedValues,
    }
    if (list === 'plans') {
      nextState.selectedProfitPlan = nextSelectedProfitPlan
    }
    this.setState(nextState, () => {
      if (list === 'plans') {
        this.calculateProjectedProfits(goal, cost, profit, nextSelectedProfitPlan)
      } else {
        this.calculateProjectedProfits(goal, cost, profit)
      }
      this.refreshNewProgramReady()
    })
  }

  handleCoachSelectionChange = (choices) => {
    const selectedValues = (choices || []).map((choice) => choice.value).filter((value) => value)
    this.setState({
      selectedCoachValues: selectedValues,
      assistantCoaches: selectedValues.slice(1),
    }, this.refreshNewProgramReady)
  }

  handleProfitPlanChange = (event) => {
    const selectedProfitPlan = event && event.target ? event.target.value : ''
    this.setState(
      { selectedProfitPlan },
      () => this.calculateProjectedProfits('enrollment_goal', 'expected_costs', 'projected_program_profits', selectedProfitPlan)
    )
  }
  
  calculateProjectedProfits = (goal, cost, projected_profit, planId) => {
    console.log('values', goal, cost, projected_profit)
    var PLANS = this.state.priceMap
    var goalField = document.getElementById(`${goal}`)
    var costField = document.getElementById(`${cost}`)
    var projectedField = document.getElementById(`${projected_profit}`)
    if (!goalField || !costField || !projectedField) {
      return
    }
    var GOAL = +goalField.value
    var COST = +costField ? +costField.value : 0
    var selectedPlanId = planId || this.state.selectedProfitPlan || this.state.plans[0]
    switch (goal) {
      case 'team_goal':
        if (this.state.team_fees.length > 0) {
          var profit = PLANS[this.state.team_fees[0]] * GOAL - +costField.value
        } else {
          profit = 0
        }
        break
      case 'player_goal':
        if (this.state.player_fees.length > 0) {
          var profit = PLANS[this.state.player_fees[0]] * GOAL - +costField.value
        } else {
          profit = 0
        }
        break
      case 'enrollment_goal':
        if (this.state.plans.length > 0 && selectedPlanId && PLANS[selectedPlanId]) {
        var profit = PLANS[selectedPlanId] * GOAL - +costField.value
        } else {
          profit = 0
        }
        break
      default:
        alert('invalid form field')
      }
    profit = Number((Number(profit) || 0).toFixed(2))
    projectedField.value = profit
  }

  checkFields(type, suppressAlerts = false){
    const { VTsessions, sessions} = this.state
    const fail = (message) => {
      if (!suppressAlerts) {
        alert(message)
      }
      return false
    }
    if(type === "new" || type === "update") {
      if (this.state.league) {
        console.log('Check fields for Ext. Leagues')
        if (this.getFieldValue("commissioner_1") === ""){
          return fail("From the Programming Tab, please select a commissioner");
        } else if (this.getFieldValue("player_goal") === ""){
          return fail("From the Pricing Tab, Please enter player goal");
        } else if (this.getFieldValue("player_max") === ""){
          return fail("From the Pricing Tab, please enter player maximum");
        } else if (+this.getFieldValue("player_max") < +this.getFieldValue("player_goal")){
          return fail("From the Pricing Tab, Enrolment Maximum cannot be less than Enrolment Goal ");
        } else if (this.getFieldValue("player_costs") === ""){
          return fail("From the Pricing Tab, please enter player costs");
        } else if (this.state.team_fees.length === 0){
          return fail("From the Pricing Tab, please add at least one Team Fee plan.");
        } else if (this.state.player_fees.length === 0){
          return fail("From the Pricing Tab, please add at least one Player Fee plan.");
        }
      } else {
        console.log('Check fields for Programs')
        if (this.getFieldValue("type") === "") {
          return fail("From the Programming Tab, please choose a type");
        } else if (this.getFieldValue("head_coach") === ""){
          return fail("From the Programming Tab, please select a Coach");
        } else if (this.getFieldValue("enrollment_goal") === ""){
          return fail("From the Pricing Tab, Please enter enrollment goal");
        } else if (this.getFieldValue("enrollment_maximum") === ""){
          return fail("From the Pricing Tab, please enter enrollment maximum");
        } else if (+this.getFieldValue("enrollment_maximum") < +this.getFieldValue("enrollment_goal")){
          return fail("From the Pricing Tab, Enrolment Maximum cannot be less than Enrolment Goal ");
        } else if (this.state.plans.length === 0){
          return fail("From the Pricing Tab, please add at least one Payment Plan.");
        }
      }
      if (this.getFieldValue("season") === ""){
        return fail("From the Programming Tab, please choose a season");
      } else if (this.getFieldValue("ages").trim() === ""){
        return fail("From the Programming Tab, please enter an age group");
      } else if (this.getFieldValue("division") === ""){
        return fail("From the Programming Tab, please choose division");
      } else if (this.getFieldValue("group_name").trim() === ""){
        return fail("From the Programming Tab, please enter group name");
      } else if (this.getFieldValue("start_date") === ""){
        return fail("From the Programming Tab, please select a Program Start Date");
      } else if (this.getFieldValue("end_date") === ""){
        return fail("From the Programming Tab, please select a Program End Date");
      } else if (this.getFieldValue("registration_start_date") === ""){
        return fail("From the Programming Tab, please select a Open Enrolment date");
      } else if (this.getFieldValue("registration_end_date") === ""){
        return fail("From the Programming Tab, please select a Close Enrolment date");
      } else if (new Date(this.getFieldValue("registration_start_date")) > new Date(this.getFieldValue("registration_end_date"))){
        return fail("From the Programming Tab, please make the Close Enrolment later than the Open Enrolment.");
      } else if (new Date(this.getFieldValue("start_date")) > new Date(this.getFieldValue("end_date"))){
        return fail("From the Programming Tab, please make the Program End Date later than the Program Start Date.");
      } else if (new Date(this.getFieldValue("registration_start_date")) > new Date(this.getFieldValue("start_date"))){
        return fail("From the Programming Tab, please make the Program Start later than the Open Enrolment.");
      } else if (new Date(this.getFieldValue("registration_end_date")) > new Date(this.getFieldValue("end_date"))){
        return fail("From the Programming Tab, please make the Program End Date later than the Close Enrolment Date.");
      } else if (sessions.length === 0 && VTsessions.length === 0){
        return fail("From the Programming Tab, please enter at least one session");
      } else if (this.state.addSessionVisible|| this.state.addVTVisible){
        return fail("From the Programming Tab, please Accept or x your final Session.");
      } else if (this.state.addAssistantCoachVisible === true){
        return fail("From the programming Tab, please complete your unsaved assistant coach");
      } else if( this.state.waiver_type === "1" && this.state.custom_waiver === ""){
        return fail("From the Waiver tab, you selected Custom Waiver but have not added text.  Please, add text, or select Organization Waiver.");
      } else {
        return true;
      }
    }
  }

  addSessionVisible = () => {
    this.setState({ 
      addSessionVisible: true,
      session_day: 'select',
      session_date: null,
      session_location_mode: this.state.organization_venues.length > 0 ? 'existing' : 'custom',
      selectedVenueIndex: this.state.organization_venues.length > 0 ? '0' : '',
      session_location_custom: '',
      session_repeat_weekly: false,
    });
  }

  handleSessionVenueMode = (e) => {
    this.setState({
      session_location_mode: e.target.value,
      selectedVenueIndex: e.target.value === 'existing' && this.state.organization_venues.length > 0 ? '0' : '',
      session_location_custom: e.target.value === 'custom' ? this.state.session_location_custom : '',
    }, this.refreshNewProgramReady)
  }

  handleSessionVenueSelect = (e) => {
    this.setState({
      selectedVenueIndex: e.target.value,
      session_location_custom: '',
    }, this.refreshNewProgramReady)
  }

  handleSessionDayChange = (e) => {
    const session_day = e.target.value
    this.setState({
      session_day,
      session_date: session_day === 'Date' ? this.state.session_date : null,
    }, this.refreshNewProgramReady)
  }

  handleSessionDateChange = (session_date) => {
    this.setState({ session_date }, this.refreshNewProgramReady)
  }

  formatSessionDateInput = (dateValue) => {
    if (!dateValue) {
      return ''
    }
    if (dateValue.format) {
      return dateValue.format('YYYY-MM-DD')
    }
    const date = new Date(dateValue)
    if (Number.isNaN(date.getTime())) {
      return ''
    }
    return date.toISOString().slice(0, 10)
  }

  getSessionDayPattern = (dayValue) => {
    const normalized = (dayValue || '').toString().trim()
    const dayMap = {
      Monday: [1],
      Tuesday: [2],
      Wednesday: [3],
      Thursday: [4],
      Friday: [5],
      Saturday: [6],
      Sunday: [0],
      Weekdays: [1, 2, 3, 4, 5],
      Weekends: [0, 6],
    }
    return dayMap[normalized] || []
  }

  buildSessionDates = (dayValue, repeatWeekly, sessionDate) => {
    const startDate = this.state.start_date ? Moment(this.state.start_date).startOf('day') : null
    const endDate = this.state.end_date ? Moment(this.state.end_date).endOf('day') : null
    const selectedDate = sessionDate ? Moment(sessionDate).startOf('day') : null
    const weekdays = this.getSessionDayPattern(dayValue)

    if (dayValue === 'Date') {
      if (!selectedDate || !selectedDate.isValid() || !startDate || !startDate.isValid() || !endDate || !endDate.isValid()) {
        return []
      }

      if (selectedDate.isBefore(startDate, 'day') || selectedDate.isAfter(endDate, 'day')) {
        return []
      }

      if (repeatWeekly) {
        const weeklyDates = []
        const cursor = selectedDate.clone()

        while (cursor.isSameOrBefore(endDate, 'day')) {
          weeklyDates.push(cursor.clone())
          cursor.add(7, 'days')
        }

        return weeklyDates
      }

      return [selectedDate]
    }

    if (!startDate || !startDate.isValid() || !endDate || !endDate.isValid() || !weekdays.length) {
      return []
    }

    const matches = []
    const cursor = startDate.clone()

    while (cursor.isSameOrBefore(endDate, 'day')) {
      if (weekdays.includes(cursor.day())) {
        matches.push(cursor.clone())
        if (!repeatWeekly) {
          break
        }
      }
      cursor.add(1, 'day')
    }

    return matches
  }

  addSession = (change) => {
    var tempSessions = this.state.sessions.slice();
    var start_time = Moment(this.state.session_start_time, 'hh:mm')
    var end_time = Moment(this.state.session_end_time, 'hh:mm')
    const selectedVenue = this.state.organization_venues[this.state.selectedVenueIndex]
    const sessionLocation = this.state.session_location_mode === 'existing'
      ? (selectedVenue ? `${selectedVenue.name} - ${selectedVenue.address}` : '')
      : (this.state.session_location_custom || '').trim()

    const sessionType = document.getElementById("session_type").value
    const sessionDay = this.state.session_day
    const sessionDate = this.state.session_date
    const repeatWeekly = this.state.session_repeat_weekly
    const sessionDates = this.buildSessionDates(sessionDay, repeatWeekly, sessionDate)

    if(document.getElementById("session_type").value === "" || this.state.session_day === "select" ||
      sessionLocation === ""){
        alert("Please enter all the fields in session")
    } else if (!this.state.start_date) {
        alert("Please set the program start date before adding sessions.")
    } else if (!this.state.end_date) {
        alert("Please set the program end date before adding sessions.")
    } else if (sessionDay === 'Date' && (!sessionDate || !Moment(sessionDate).isValid())) {
        alert("Please choose a session date.")
    } else if (sessionDay === 'Date' && sessionDates.length === 0) {
        alert("Please choose a session date within the program start and end dates.")
    } else if (repeatWeekly && sessionDates.length === 0) {
        alert("Please set the program start and end dates before creating weekly sessions.")
    } else if (!start_time.isBefore(end_time)){
      alert("From the Programming Tab, please make the Session End Time later than the Sessions Start Time.")
    } else {
      const seriesId = repeatWeekly ? makeUniqueKey() : null
      const generatedSessions = sessionDates.length > 0 ? sessionDates : [this.state.start_date ? Moment(this.state.start_date).startOf('day') : Moment().startOf('day')]
      generatedSessions.forEach((sessionDate, occurrenceIndex) => {
        tempSessions.push({
          id: makeUniqueKey(),
          series_id: seriesId,
          recurring: repeatWeekly,
          recurrence: repeatWeekly ? {
            frequency: 'weekly',
            by_day: sessionDay,
            count: generatedSessions.length,
            interval: 1,
          } : null,
          occurrence_index: occurrenceIndex + 1,
          occurrence_count: generatedSessions.length,
          type: sessionType,
          day: sessionDay,
          date: sessionDate && sessionDate.isValid && sessionDate.isValid() ? sessionDate.format('YYYY-MM-DD') : null,
          start_time: Moment(start_time, 'hh:mm').format('hh:mm A'),
          end_time: Moment(end_time, 'hh:mm').format('hh:mm A'),
          location: sessionLocation
        });
      });
      this.setState({ 
        addSessionVisible: false, 
        sessions: sortProgramSessions(tempSessions),
        session_day: 'select',
        session_date: null,
        session_location_custom: '',
        selectedVenueIndex: '',
        session_repeat_weekly: false,
      }, this.refreshNewProgramReady);
    }
  }

  cancelSession = (change) => {
    this.setState({ 
      addSessionVisible: false,
      session_start_time: '12:00',
      session_end_time: '12:00',
      session_day: 'select',
      session_date: null,
      session_location_mode: this.state.organization_venues.length > 0 ? 'existing' : 'custom',
      selectedVenueIndex: this.state.organization_venues.length > 0 ? '0' : '',
      session_location_custom: '',
      session_repeat_weekly: false,
    }, this.refreshNewProgramReady)
  }

  handleChange = (val, index, field) => {
    var tempSessions = this.state.sessions.slice()
    switch (field) {
      case 'type':
        tempSessions[index].type = val.target.value
        break
      case 'day':
        tempSessions[index].day = val.target.value
        if (val.target.value === 'Date') {
          tempSessions[index].date = tempSessions[index].date || null
        } else {
          tempSessions[index].date = null
        }
        break
      case 'date':
        tempSessions[index].date = val.target.value
        break
      case 'start_time':
        tempSessions[index].start_time = Moment(val.target.value, 'hh:mm').format('hh:mm A')
        break
      case 'end_time':
        tempSessions[index].end_time = Moment(val.target.value, 'hh:mm').format('hh:mm A')
        break
      case 'enrol_max':
        tempSessions[index].enrol_max = val.target.value
        break
      case 'location':
        tempSessions[index].location = val.target.value
        break
      default:
        alert('invalid form field')
    }
    this.setState({ sessions: sortProgramSessions(tempSessions) }, this.refreshNewProgramReady)
  }

  handleSessionTime = (time, val) => {
    this.setState({[time]: val.target.value }, this.refreshNewProgramReady)
  }

  removeSession = (index) => {
    var tempSessions = this.state.sessions.slice()
    tempSessions.splice(index, 1)
    this.setState({ sessions: sortProgramSessions(tempSessions) }, this.refreshNewProgramReady)
  }

  cloneSession = (index) => {
    const tempSessions = this.state.sessions.slice()
    const sessionToClone = tempSessions[index]

    if (!sessionToClone) {
      return
    }

    tempSessions.splice(index + 1, 0, {
      ...sessionToClone,
      id: makeUniqueKey(),
    })
    this.setState({ sessions: sortProgramSessions(tempSessions) }, this.refreshNewProgramReady)
  }

  renderSessions = () => {
    const { clone } = this.state
    const { selectedItem } = this.props
    var expired = selectedItem ? (selectedItem.status === "Expired" ? true : false) : ""

    var addControl = null;
    if (this.state.addSessionVisible) {
      const venueOptions = this.state.organization_venues.map((venue, index) => (
        <option key={venue.id || `${venue.name}-${index}`} value={index}>
          {venue.name} - {venue.address}
        </option>
      ))
      addControl = 
        <div className="program-session-card program-session-card-draft">
        <div className="program-session-card-top">
          <div className="program-session-field">
            <label className="program-session-field-label" htmlFor="session_type">Type</label>
            <FormControl className="opaque-grey" type="text" id="session_type" placeholder="Practice" disabled={clone}/>
          </div>
          <div className="program-session-field">
            <label className="program-session-field-label" htmlFor="session_day">Day</label>
            <FormControl
              className="opaque-grey"
              componentClass="select"
              id="session_day"
              value={this.state.session_day}
              onChange={this.handleSessionDayChange}
              disabled={expired ? expired : clone}
            >
              {programSessionDayOptions}
            </FormControl>
            {this.state.session_day === 'Date' && (
              <FormControl
                className="opaque-grey program-native-date"
                type="date"
                id="session_date"
                name="session_date"
                value={this.formatSessionDateInput(this.state.session_date)}
                onChange={(event) => this.handleSessionDateChange(event.target.value ? new Date(event.target.value) : null)}
                disabled={expired ? expired : clone}
              />
            )}
          </div>
          <div className="program-session-field">
            <label className="program-session-field-label" htmlFor="session_start_time">Start</label>
            <FormControl className="opaque-grey" type="time" placeholder="Start Time" defaultValue={this.state.session_start_time} onChange={(e) => this.handleSessionTime('session_start_time', e)} id="session_start_time" disabled={expired ? expired : clone}/>
          </div>
          <div className="program-session-field">
            <label className="program-session-field-label" htmlFor="session_end_time">End</label>
            <FormControl className="opaque-grey" type="time" placeholder="End Time" id="session_end_time" defaultValue={this.state.session_end_time} onChange={(e) => this.handleSessionTime('session_end_time', e)} disabled={expired ? expired : clone}/>
          </div>
        </div>
        <div className="program-session-card-bottom">
          <div className="program-session-location-block">
            <label className="program-session-field-label" htmlFor="session_location_select">Location</label>
            {this.state.organization_venues.length > 0 ? (
              <div className="session-venue-picker">
                <FormControl
                  className="opaque-grey"
                  componentClass="select"
                  id="session_location_select"
                  value={this.state.session_location_mode === 'existing' ? this.state.selectedVenueIndex : 'custom'}
                  onChange={(e) => {
                    if (e.target.value === 'custom') {
                      this.handleSessionVenueMode(e)
                    } else {
                      this.setState({
                        session_location_mode: 'existing',
                        selectedVenueIndex: e.target.value,
                      }, this.refreshNewProgramReady)
                    }
                  }}
                  disabled={expired ? expired : clone}
                >
                  {venueOptions}
                  <option value="custom">Custom venue</option>
                </FormControl>
                {this.state.session_location_mode === 'custom' && (
                  <FormControl
                    className="opaque-grey session-location-input session-location-custom"
                    type="text"
                    id={"session_location"}
                    placeholder="Location"
                    value={this.state.session_location_custom}
                    onChange={(e) => this.setState({ session_location_custom: e.target.value }, this.refreshNewProgramReady)}
                    disabled={expired ? expired : clone}
                  />
                )}
              </div>
            ) : (
              <FormControl className="opaque-grey" type="text" id={"session_location"} placeholder="Location" disabled={expired ? expired : clone}/>
            )}
            <label className="program-session-repeat">
              <input
                type="checkbox"
                checked={this.state.session_repeat_weekly}
                onChange={(e) => this.setState({ session_repeat_weekly: e.target.checked }, this.refreshNewProgramReady)}
                disabled={expired ? expired : clone}
              />
              <span>Repeat weekly until program end</span>
            </label>
            <div className="program-session-repeat-help">Creates one dated occurrence for every matching week, in order, for future calendar export.</div>
          </div>
          <div className="program-session-actions">
            <Button className="modalbutton-add-row" onClick={this.addSession}>Accept</Button>
            <button type="button" className="program-session-cancel" onClick={this.cancelSession} aria-label="Cancel session">
              <FontAwesomeIcon icon={faTimes} size="1x" />
            </button>
          </div>
        </div>
      </div>
    }
    return (
      <div className="program-session-section">
        <div className="program-session-list program-session-list-inline">
        { sortProgramSessions(this.state.sessions).map((input, index) => {
          var start_time = Moment(input.start_time, 'hh:mm A').format('HH:mm');
          var end_time = Moment(input.end_time, 'hh:mm A').format('HH:mm')
          return (
            <div className="program-session-card" key={input.id || `${input.type}-${index}`}>
              <button
                type="button"
                className="program-session-remove"
                title="Delete session"
                aria-label="Delete session"
                onClick={() => this.removeSession(index)}
                disabled={expired ? expired : clone}
              >
                <FontAwesomeIcon icon={faTimes} size="1x" />
              </button>
              <div className="program-session-card-top">
                <div className="program-session-field">
                  <label className="program-session-field-label">Type</label>
                  <FormControl value={input.type} className="opaque-grey" type="text" onChange={(val)=> this.handleChange(val, index, 'type')} disabled={expired ? expired : clone}/>
                </div>
                <div className="program-session-field">
                  <label className="program-session-field-label">Day</label>
                  <FormControl value={input.day} className="opaque-grey" componentClass="select" onChange={(val)=> this.handleChange(val, index, 'day')} placeholder="select day" disabled={expired ? expired : clone}>
                    {programSessionDayOptions}
                  </FormControl>
                  {input.day === 'Date' && (
                    <FormControl
                      className="opaque-grey program-native-date"
                      type="date"
                      id={`saved_session_date_${index}`}
                      name={`saved_session_date_${index}`}
                      value={this.formatSessionDateInput(input.date)}
                      onChange={(event) => this.handleChange({ target: { value: event.target.value ? event.target.value : null } }, index, 'date')}
                      disabled={expired ? expired : clone}
                    />
                  )}
                </div>
                <div className="program-session-field">
                  <label className="program-session-field-label">Start</label>
                  <FormControl className="opaque-grey" type="time" defaultValue={start_time} onChange={(val)=> this.handleChange(val, index, 'start_time')} id="saved_session_start_time" name="saved_session_start_time" disabled={expired ? expired : clone}/>
                </div>
                <div className="program-session-field">
                  <label className="program-session-field-label">End</label>
                  <FormControl className="opaque-grey" type="time" defaultValue={end_time} onChange={(val)=> this.handleChange(val, index, 'end_time')} id="saved_session_end_time" name="saved_session_end_time" disabled={expired ? expired : clone}/>
                </div>
              </div>
              <div className="program-session-card-bottom">
                <div className="program-session-location-block">
                  <label className="program-session-field-label">Location</label>
                  <FormControl
                    value={input.location}
                    onChange={(val)=> this.handleChange(val, index, 'location')}
                    className="opaque-grey session-location-input"
                    type="text"
                    disabled={expired ? expired : clone}
                  />
                </div>
                <div className="program-session-actions">
                  <Button
                    type="button"
                    className="session-icon-btn"
                    title="Duplicate session"
                    aria-label="Duplicate session"
                    onClick={() => this.cloneSession(index)}
                    disabled={expired ? expired : clone}
                  >
                    <FontAwesomeIcon icon={faClone} size="1x" />
                  </Button>
                </div>
              </div>
              <div className="program-session-meta" style={{ fontSize: '0.9rem' }}>
                {formatSessionDateLabel(input)} · {start_time} - {end_time}
                {input.recurring ? ' · weekly series' : ''}
              </div>
            </div>
          )
        })}
        </div>
        {addControl}
        <Row>
          <Col sm={3}>
            <Button className="add-session-btn" onClick={this.addSessionVisible} disabled={expired ? expired : clone || this.state.addSessionVisible}>Add Session</Button>
          </Col>
        </Row>
    </div>
    )
  }

  // ----------- VIRTUAL TRAINING SESSIONS -----------
  addVTSession = (change) => {
    this.setState({ addVTVisible: true }, this.refreshNewProgramReady)
    var tempSessions = this.state.VTsessions.slice();
    console.log('add VT Session', tempSessions)
    tempSessions.push({
      name: "",
      date: null,
      start_time: "12:00",
      end_time: "12:00",
      coach: ""
    });
    this.setState({ VTsessions: tempSessions }, this.refreshNewProgramReady);
  }

  cancelVTSession = (i, cancel) => {
    console.log('cancel session, i=', i)
    var tempSessions = this.state.VTsessions.slice()
    tempSessions.splice(i, 1)
    this.setState({ 
      addVTVisible: cancel ? false : this.state.addVTVisible,
      VTsessions: tempSessions
    }, this.refreshNewProgramReady)
  }

  addVTS = (i) => {
    var tempSession = this.state.VTsessions.slice()
    var start_time = Moment(tempSession[i].start_time,'hh:mm')
    var end_time = Moment(tempSession[i].end_time, 'hh:mm')
    if (!tempSession[i].date || tempSession[i].coach === "" || tempSession[i].name === "") {
      window.alert('Please fill all fields')
    } else if (start_time === end_time) {
      window.alert('Start and End time cannot be the same')
    } else if (!start_time.isBefore(end_time)) {
      console.log('start -', start_time, 'end time - ', end_time)
      alert("End time must be after Start time")
    } else {
      tempSession[i].addSession = true
      tempSession[i].start_time = Moment(tempSession[i].start_time,'hh:mm').format('hh:mm A')
      tempSession[i].end_time = Moment(tempSession[i].end_time,'hh:mm').format('hh:mm A')
      console.log('adding VT session', tempSession)
      this.setState({ 
        addVTVisible: false,
        VTsessions: tempSession
       }, this.refreshNewProgramReady)
    }
    
  }

  handleVTs = (val, index, field) => {
    var tempSessions = this.state.VTsessions.slice()
    switch (field) {
      case 'name':
        tempSessions[index].name = val.target.value
        break
      case 'date':
        tempSessions[index].date = val
        break
      case 'start':
        tempSessions[index].start_time = val.target.value
        break
      case 'end':
        tempSessions[index].end_time = val.target.value
        break
      case 'coach':
        tempSessions[index].coach = val.target.value
        break
      default:
        alert('invalid form field')
    }
    this.setState({ VTSessions: tempSessions }, this.refreshNewProgramReady)
  }

  VTSessions = () => {
    const { clone, coachOptions } = this.state
    const { selectedItem } = this.props
    var expired = selectedItem ? (selectedItem.status === "Expired" ? true : false) : ""

    var addControl = null;
    if (this.state.addVTVisible) {
      this.state.VTsessions.map((input, index) => {
        addControl = 
        <Row>
          <Col sm={2}>
            <FormControl className="opaque-grey" type="text" defaultValue={input.name} placeholder="Virtual Session" disabled={clone} onChange={(e) => this.handleVTs(e, index, 'name')}/>
          </Col>
          <Col sm={2}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <MuiThemeProvider theme={hoopstirTheme}>
                <DatePicker
                  openTo="year" format="MM/DD/YYYY" label="" clearable
                  views={["year", "month", "date"]} value={input.date}
                  onChange={(date) => this.handleVTs(date, index, 'date')}
                  className="DOB"
                  placeholder="MM/DD/YYYY"
                  disabled={expired ? expired : clone}
                />
              </MuiThemeProvider>
            </MuiPickersUtilsProvider>
          </Col>
          <Col sm={2}>
            <FormControl className="opaque-grey" type="time" defaultValue={input.start_time} onChange={(e) => this.handleVTs(e, index, 'start')} id="broadcast_start" disabled={expired ? expired : clone}/>
          </Col>
          <Col sm={2}>
            <FormControl className="opaque-grey" type="time" id="broadcast_end" defaultValue={input.end_time} onChange={(e) => this.handleVTs(e, index, 'end')} disabled={expired ? expired : clone}/>
          </Col>
          <Col sm={2}>
            <FormGroup>           
              <FormControl className="opaque-grey" name="head_coach" value={input.coach}componentClass="select" id="head_coach" disabled={expired ? expired : clone} onChange={(val)=> this.handleVTs(val, index, 'coach')} >
                {coachOptions}
              </FormControl>
            </FormGroup>
          </Col>
          <Col sm={2}>
            <Button style={{width: '90%', marginRight: '5px'}}className="deleterow" onClick={() => this.addVTS(index)}>Accept</Button>
            <a onClick={() => this.cancelVTSession(index, 'cancel')}><FontAwesomeIcon icon={faTimes} size="1x" color='white' disabled={expired ? expired : clone}/></a>
          </Col>
        </Row>
      }) 
    } else {
      addControl =
      <Row>
        <Col sm={3}>
          <Button className="add-session-btn" onClick={() => this.addVTSession()} disabled={expired ? expired : clone}>Add Virtual Session</Button>
        </Col>
      </Row>
    }
    return (
      <div>
        <Row className="form-group">
          <Col sm={2}>Name</Col>
          <Col sm={2}>Date</Col>
          <Col sm={2}>Start Time</Col>
          <Col sm={2}>End Time</Col>
          <Col sm={4}>Coach</Col>
        </Row>
        { this.state.VTsessions.map((input, i) => {
          let start = Moment(input.start_time, 'hh:mm A').format('HH:mm');
          let end = Moment(input.end_time, 'hh:mm A').format('HH:mm')
          return (
            <Row>
              { input.addSession &&
              <Fragment>
                <Col sm={2}>
                  <FormControl className="opaque-grey" type="text" defaultValue={input.name} value={input.name} placeholder="Virtual Session" disabled={clone} onChange={(e) => this.handleVTs(e, i, 'name')}/>
                </Col>
                <Col sm={2}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <MuiThemeProvider theme={hoopstirTheme}>
                    <DatePicker
                      openTo="year" format="MM/DD/YYYY" label="" clearable
                      views={["year", "month", "date"]} value={input.date}
                      onChange={(date) => this.handleVTs(date, i, 'date')}
                      className="DOB"
                      placeholder="MM/DD/YYYY"
                      disabled={expired ? expired : clone}
                    />
                  </MuiThemeProvider>
                </MuiPickersUtilsProvider>
              </Col>
              <Col sm={2}>
                <FormControl className="opaque-grey" type="time" defaultValue={start} onChange={(val)=> this.handleVTs(val, i, 'start')} disabled={expired ? expired : clone}/>
              </Col>
              <Col sm={2}>
                <FormControl className="opaque-grey" type="time" defaultValue={end} onChange={(val)=> this.handleVTs(val, i, 'end')} disabled={expired ? expired : clone}/>
              </Col>
              <Col sm={2}>
                <FormGroup>           
                  <FormControl className="opaque-grey" name="oach" value={input.coach}componentClass="select" disabled={expired ? expired : clone} onChange={(val)=> this.handleVTs(val, i, 'coach')} >
                    {coachOptions}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col sm={2}>
                <Button className="deleterow" onClick={() => this.cancelVTSession(i)} disabled={expired ? expired : clone}>Delete</Button>
              </Col>
              </Fragment>
              }
            </Row>
          )
        })}
        {addControl}
    </div>
    )
  }

  // ----------------------------------- 

  cancelPlan = (list) => {
    this.setState({ [`${list}_visible`]: false }, this.refreshNewProgramReady)
  }

  renderSavedRow = (value, onDelete, disabled, key) => {
    return (
      <Row key={key} inline>
        <FormGroup className="col-sm-12">
          <InputGroup className="col-sm-11">
            <FormControl disabled value={value} className="opaque-grey" type="text" />
            <InputGroup.Button>
              <Button className="deleterow" onClick={onDelete} disabled={disabled}>Delete</Button>
            </InputGroup.Button>
          </InputGroup>
        </FormGroup>
        <br/><br/>
      </Row>
    )
  }

  renderPlans = (plan, goal, cost, profit, list) => {
    const { clone } = this.state
    const { selectedItem } = this.props
    var expired = selectedItem ? (selectedItem.status === "Expired" ? true : false) : ""
    const options = this.state.availablePlanOptions || []
    const selectedValues = (this.state[list] || []).filter(Boolean)
    const selectedOptions = options.filter((option) => selectedValues.includes(option.value))

    return (
      <div className="multi-chip-field">
        <VirtualizedSelect
          className="udf-multi-select opaque-grey"
          name={plan}
          value={selectedOptions}
          options={options}
          multi={true}
          onChange={(choices) => this.handlePlanSelectionChange(choices, goal, cost, profit, list)}
          placeholder={expired || clone ? 'No plans selected' : 'Select a plan'}
          disabled={expired ? expired : clone}
        />
      </div>
    )
  }

  cancelAssistantCoach = () => {
    this.setState({ addAssistantCoachVisible: false }, this.refreshNewProgramReady)
  }

  renderAssistantCoaches = () => {
    const { clone } = this.state
    const { selectedItem } = this.props
    var expired = selectedItem ? (selectedItem.status === "Expired" ? true : false) : false

    if (this.state.coachMap) {
      var addControl = null;
      if (this.state.addAssistantCoachVisible) {
        addControl =
          <Row className="add-plan">
            <Col sm={8}>
              <FormGroup>
                <FormControl
                  className="opaque-grey"
                  name="assistant_coach"
                  componentClass="select"
                  id="new_assistant_coach"
                >
                  {this.state.coachOptions}
                </FormControl>
              </FormGroup>
            </Col>
            <Col>
              <Button className="modalbutton-add-row" onClick={this.addAssistantCoach}>Accept</Button>
            </Col>
            <Col>
              <Button className="cancel-option" onClick={this.cancelAssistantCoach}>Cancel</Button>
            </Col>
          </Row>
      } else {
        addControl =
          <div style={{ paddingTop: '12px' }}>
            <Button className="add-session-btn" onClick={this.addAssistantCoachVisible} disabled={expired || clone}>
              { this.state.league || this.state.defaultPlaceholders.league ? 'Add personnel' : 'Add coach' }
            </Button>
          </div>

      }
      return (
        <div>
          {this.state.assistantCoaches.filter((input) => input && this.state.coachMap[input]).map((input, index) => {
            return this.renderSavedRow(
              this.state.coachMap[input],
              this.removeAssistantCoach,
              false,
              index
            )
          })}
          {addControl}
        </div>
      )
    }
  }

  removeAssistantCoach = (clicked) => {
    var tempAssistantCoaches = this.state.assistantCoaches;
    tempAssistantCoaches.splice(clicked.target.value, 1);
    this.setState({ assistantCoaches: tempAssistantCoaches });
  }

  addAssistantCoachVisible = () => {
    this.setState({ addAssistantCoachVisible: true });
  }

  addAssistantCoach = (change) => {
    var tempAssistantCoaches = this.state.assistantCoaches;
    var newAssistantCoach = document.getElementById("new_assistant_coach").value;
    if (newAssistantCoach === "") {
      alert("Please select a coach")
      return
    }
    tempAssistantCoaches.push(newAssistantCoach);
    this.setState({ addAssistantCoachVisible: false, assistantCoaches: tempAssistantCoaches });
  }

  renderSubmitButtons = () => {
    const { clone, spinner } = this.state
    const { selectedItem } = this.props
    var expired = selectedItem ? (selectedItem.status === "Expired" ? true : false) : ""
    const canCreateNewProgram = this.state.mode === "edit" ? true : this.state.newProgramReady
    const createProgramBlocker = this.getCreateProgramBlocker()
    const createProgramBlockedMessage = createProgramBlocker
      ? `Missing: ${createProgramBlocker.label} (${createProgramBlocker.section})`
      : "Complete the required fields on Details and Pricing first"

    var submitButtons = [];
    var defaultPlaceholders = this.state.defaultPlaceholders
    // submitButtons.push(
    //   spinner ?
    //   ""
    //   :
    //   <Col key={makeUniqueKey()} sm={2} style={{textAlign:"center"}}>
    //     <Button className="cancel-option" onClick={this.handleCloseModal}>CANCEL</Button>
    //   </Col>
    //   );
    submitButtons.push(" ")
    if (this.state.mode === "edit") {
      if (spinner) {
        submitButtons.push(<div key={makeUniqueKey()} className="enrolment-loader"></div>)
      } else {
      submitButtons.push(
        <div className="modal-formbuttons">
          <Row className="modal-btn-container">
            <Button className="modalbutton-cancel" onClick={this.handleCloseModal}>
              Cancel
            </Button>
            <Button className="button2 modalbtn" bsStyle="primary"  onClick={this.handleArchiveSubmit}>
              { this.state.league || defaultPlaceholders.league ? 'Archive League' : 'Archive Program' }
            </Button>
            <Button 
                className={ expired ? "grey": "button2"}
                bsStyle="primary"
                onClick={this.handleUpdateSubmit}
                className={ expired ? "grey": "button2 modalbtn"}
              >
                { this.state.league || defaultPlaceholders.league ? 'Update League' : 'Update Program' }
              </Button>
          </Row>
          </div>
          );
        submitButtons.push(" ")
        // submitButtons.push(
        //   <div>
        //     <Col key={makeUniqueKey()} sm={3}>
        //       <Button 
        //         className={ expired ? "grey": "button2"}
        //         bsStyle="primary"
        //         onClick={this.handleUpdateSubmit}
        //         className={ expired ? "grey": "button2 modalbtn"}
        //       >
        //         { this.state.league || defaultPlaceholders.league ? 'Update League' : 'Update Program' }
        //       </Button>
        //     </Col>
        //   </div>
        //   );
      }
    } else { // mode is new
      if (spinner) {
        submitButtons.push(<div key={makeUniqueKey()} className="enrolment-loader"></div>)
      } else if (this.state.activeTab === '1') {
        submitButtons.push(
          <div className="modal-formbuttons">
            <Row className="modal-btn-container">
              <Button className="cancel-option" onClick={this.handleCloseModal}>
                Cancel
              </Button>
              <Button className="button2 modalbtn" type="button" onClick={this.goToPricingTab}>
                Next
              </Button>
            </Row>
          </div>
        )
      } else if (this.state.activeTab === '2') {
        submitButtons.push(
          <div className="modal-formbuttons">
            <Row className="modal-btn-container">
              <Button className="cancel-option" onClick={this.handleCloseModal}>
                Cancel
              </Button>
              <Button className="button2 modalbtn" type="button" onClick={this.goToWaiversTab}>
                Next
              </Button>
            </Row>
          </div>
        )
      } else {
        submitButtons.push(
          <div className="modal-formbuttons">
            <Row className="modal-btn-container">
              <Button className="cancel-option" onClick={this.handleCloseModal}>
                Cancel
              </Button>
              <Button className="button2 modalbtn" type="button" onClick={this.goToPricingTab}>
                Back
              </Button>
              <Button
                className={canCreateNewProgram ? "" : "grey"}
                type="button"
                onClick={this.handleNewSubmit}
                disabled={!canCreateNewProgram}
                title={canCreateNewProgram ? "" : createProgramBlockedMessage}
              >
                { this.state.league || defaultPlaceholders.league ? 'Create League' : 'Create Program' }
              </Button>
              {!canCreateNewProgram && createProgramBlocker && (
                <div className="program-submit-blocker" title={createProgramBlockedMessage}>
                  {createProgramBlockedMessage}
                </div>
              )}
              <Button
                className="button2 modalbtn"
                type="button"
                onClick={this.goToDetailsTab}
              >
                Next
              </Button>
            </Row>
          </div>
        )
      }
    }
    return submitButtons;
  }

  renderSeason = () => {
    const selectedSeason = this.props.selectedItem && this.props.selectedItem.season
      ? this.props.selectedItem.season
      : this.state.defaultPlaceholders.season
    const options = getSeasons(false)
    if (selectedSeason && !options.includes(selectedSeason)) {
      options.push(selectedSeason)
    }
    const seasonOptions = options.map((season) => (
      <option key={season} value={season} selected={season === selectedSeason}>
        {season}
      </option>
    ))
    this.setState({allseasonOptions: seasonOptions})
  }

  onChangeWaiverType = (event) => {
    this.setState({ waiver_type: event.target.value}, this.refreshNewProgramReady)
  }

  handleCustomWaiverChange = (waiver) => {
    this.setState({ custom_waiver: waiver.target.value }, this.refreshNewProgramReady)
  }

  handleFocus = () => {
    if (this.state.start_date === null) {
      this.setState({ start_date: Moment.utc(new Date()) })
    }
  }

  handleUDFs = choices => {
    console.log("handleUDFs", choices)
    var options = []
    if (choices !== null) {
      choices.forEach(udf => {
        options.push(udf.value)
      })
      this.setState({ programUDFs: options })
    }  
  }

  render() {
    const { defaultPlaceholders, organization_merch, coachOptions, ageVerify, league, clone, orgUDFS, programUDFs, programTypeLabels } = this.state
    const { selectedItem, type } = this.props
    const programTypeOptions = getProgramTypeOptions(programTypeLabels)
    const modalTitle = this.state.mode === "edit"
      ? (league || defaultPlaceholders.league ? "Edit League" : "Edit Program")
      : (league || defaultPlaceholders.league ? "Create League" : "Create Program")
    const summarySeason = defaultPlaceholders.season || "Season not set"
    const summaryType = type || defaultPlaceholders.type || (league ? "league" : "program")
    const summaryStatus = selectedItem
      ? selectedItem.status
      : this.state.mode === "edit"
        ? "Existing"
        : "New"
    return (
      <div className="program-modal-panel">
        <div className="program-modal-header">
          <div className="program-modal-copy">
            <div className="program-modal-kicker">Programs</div>
            <h2 className="program-modal-title">{modalTitle}</h2>
          </div>
        <div className="program-modal-summary">
            <div className="program-modal-summary-item">
              <span className="program-modal-summary-label">Season</span>
              <span className="program-modal-summary-value">{summarySeason}</span>
            </div>
            <div className="program-modal-summary-item">
              <span className="program-modal-summary-label">Type</span>
              <span className="program-modal-summary-value">{summaryType}</span>
            </div>
            <div className="program-modal-summary-item">
              <span className="program-modal-summary-label">Status</span>
              <span className="program-modal-summary-value">{summaryStatus}</span>
            </div>
          </div>
        </div>
        <Tabs activeKey={this.state.activeTab} onSelect={this.handleProgramTabSelect} id="uncontrolled-tab-example" className="program-modal-tabs">
          <Tab eventKey="1" title={league || defaultPlaceholders.league ? "League" : "Details"} bsClass="white-text">
        <ProgramTab
            allseasonOptions={this.state.allseasonOptions}
            defaultPlaceholders={defaultPlaceholders}
            division={divisionOptions}
            notifyFormChange={this.notifyFormChange}
            renderAssistantCoaches={this.renderAssistantCoaches}
            VTSessions={this.VTSessions}
            renderSessions={this.renderSessions}
            renderSubmitButtons={this.renderSubmitButtons}
            programTypeOptions={programTypeOptions}
            coachOptions= {coachOptions}
            DOB_max={this.state.DOB_max}
            start_date={this.state.start_date}
            end_date={this.state.end_date}
            registration_start_date={this.state.registration_start_date}
            registration_end_date={this.state.registration_end_date}
            handleDateChange={this.handleDateChange}
            handleFocus={this.handleFocus}
            league={league}
            handleAgeVerify={this.handleAgeVerify}
            ageVerify={ageVerify}
            requireProof={this.state.requireProof}
            openEnrolhint={this.state.openEnrolhint}
            closeEnrolhint={this.state.closeEnrolhint}
            showHint={this.showHint}
            disabled={ selectedItem ? (selectedItem.status === "Expired" ? true : clone === true ? true : false) : false }
            clonedLeague={clone}
            type={type}
            mode={this.state.mode}
            addVTVisible={this.state.addVTVisible}
            />
        </Tab>
        <Tab eventKey="2" title="Pricing">
          <PricingTab 
            renderSubmitButtons={this.renderSubmitButtons} 
            organization_merch={organization_merch} 
            defaultPlaceholders={defaultPlaceholders} 
            notifyFormChange={this.notifyFormChange}
            renderPlans={this.renderPlans}
            addPlan={this.addPlan}
            calculateProjectedProfits={this.calculateProjectedProfits}
            league={league}
            orgUDFS={orgUDFS}
            programUDFs={programUDFs}
            handleUDFs={this.handleUDFs}
            showHint={this.showHint}
            udfHint={this.state.udfHint}
            coachSelectOptions={this.state.coachSelectOptions}
            selectedCoachValues={this.state.selectedCoachValues}
            handleCoachSelectionChange={this.handleCoachSelectionChange}
            disabled={ selectedItem ? (selectedItem.status === "Expired" ? true : clone === true ? true : false) : false }
            defaultPlaceholders={defaultPlaceholders}
            plans={this.state.plans}
            availablePlanOptions={this.state.availablePlanOptions}
            planMap={this.state.planMap}
            priceMap={this.state.priceMap}
            selectedProfitPlan={this.state.selectedProfitPlan}
            handleProfitPlanChange={this.handleProfitPlanChange}
            />
          </Tab>
        <Tab eventKey="3" title="Fields & Waivers">
            <WaiverTab
            renderSubmitButtons={this.renderSubmitButtons} 
            organization_waiver={this.state.organization_waiver}
            custom_waiver={this.state.custom_waiver}
            waiver_type={this.state.waiver_type}
            onChangeWaiverType={this.onChangeWaiverType}
            handleCustomWaiverChange={this.handleCustomWaiverChange}
            league={league}
            orgUDFS={orgUDFS}
            programUDFs={programUDFs}
            handleUDFs={this.handleUDFs}
            showHint={this.showHint}
            udfHint={this.state.udfHint}
            disabled={ selectedItem ? (selectedItem.status === "Expired" ? true : clone === true ? true : false) : false }
            />
          </Tab>
        </Tabs>
      </div>
    );
  }
}

export default ProgramForm
